import React from "react";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import UpgradeWizard from "./PackageUpgradeWizard.jsx";
import TrafficPackWizard from "./PackageTrafficPackWizard.jsx";
import CurrentPackageCard from "./PackageCurrentPackageCard.jsx";
import UpgradePromoCard from "./PackageUpgradePromoCard.jsx";
import UnlimitedModeCard from "./PackageUnlimitedModeCard.jsx";
//import TrafficPackCard from "./PackageTrafficPackCard.jsx";
import UpgradeOptions from "./PackageUpgradeOptions.jsx";
import DataCapDonut from "./PackageDataCapDonutCard.jsx";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardTitle: importedStyle.cardTitle,
};

class Package extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wizard: null,
      loyaltyExtraGbToUpgradeOptions: 0,
      currentFee: null,
      selectedPackage: null,
      selectedPackageInfo: null,
      currentPackageInfo: {
        monthly_fee: null,
        rate_download: null,
        rate_upload: null,
        advertised_download_mbps: null,
        advertised_upload_mbps: null,
      },
      unlimited: false,
    };
  }

  setParentLoading = (loading) => this.setState({ loading });
  onTrafficPackClick = () => this.setState({ wizard: "trafficpack" });
  onFinishWizard = () => {
    if (
      this.props.location.state != null &&
      "action" in this.props.location.state &&
      this.props.location.state.action === "upgrade"
    ) {
      //Make sure the action state is not there. Otherwise it gets stuck
      this.props.history.push(this.props.location.pathname, {});
    }

    this.setState({ wizard: null });
  };
  onSelectUpgradePackage = (id, selectedPackageInfo) => {
    this.setState({
      selectedPackage: id,
      selectedPackageInfo,
      wizard: "upgrade",
    });
  };

  setExtraGb = (loyaltyExtraGbToUpgradeOptions) => {
    this.setState({ loyaltyExtraGbToUpgradeOptions });
  };

  setCurrentPackageInfo = (currentPackageInfo) => {
    if (/^9+$/.test(currentPackageInfo.cap)) {
      this.setState({ unlimited: true });
    }
    this.setState({ currentPackageInfo });
  };

  render() {
    const { classes } = this.props;
    if (this.state.wizard === "upgrade") {
      return (
        <UpgradeWizard
          selectedPackage={this.state.selectedPackage}
          selectedPackageInfo={this.state.selectedPackageInfo}
          currentPackageInfo={this.state.currentPackageInfo}
          extraLoyaltyGb={this.state.loyaltyExtraGbToUpgradeOptions}
          onFinishWizard={this.onFinishWizard}
          pathids={{
            upgradewizard: this.state.selectedPackage,
          }}
        />
      );
    }
    if (this.state.wizard === "trafficpack") {
      return <TrafficPackWizard onFinishWizard={this.onFinishWizard} />;
    }
    return (
      <GridContainer justify="center">
        <GridItem xs={12} md={this.state.unlimited === false ? 6 : 12}>
          <CurrentPackageCard
            passCurrentPackageInfoUp={this.setCurrentPackageInfo}
          />
        </GridItem>
        {this.state.unlimited === false ? (
          <GridItem key="donut" xs={12} md={6}>
            <DataCapDonut passExtraGbUp={this.setExtraGb} />
          </GridItem>
        ) : null}
        <GridItem xs={12}>
          <h3 className={classes.title}>Upgrade your package</h3>
        </GridItem>
        <GridItem xs={12}>
          <UpgradePromoCard />
        </GridItem>
        <GridItem xs={12}>
          <UpgradeOptions
            onSelectUpgradePackage={this.onSelectUpgradePackage}
            extraLoyaltyGb={this.state.loyaltyExtraGbToUpgradeOptions}
            currentFee={this.state.currentPackageInfo.monthly_fee}
          />
        </GridItem>
        {this.state.unlimited === false ? (
          <GridItem xs={12}>
            <UnlimitedModeCard
              currentPackageInfo={this.state.currentPackageInfo}
            />
          </GridItem>
        ) : null}
      </GridContainer>
    );
  }
}

/*
Traffic Pack
<GridItem xs={12} md={6}>
  <TrafficPackCard onTrafficPackClick={this.onTrafficPackClick} />
</GridItem>
*/

export default withStyles(styles)(Package);
